import { render, staticRenderFns } from "./FormAltr.vue?vue&type=template&id=685a16b6&"
import script from "./FormAltr.vue?vue&type=script&lang=js&"
export * from "./FormAltr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports